/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import styled from 'styled-components'
import { Col, Row } from 'antd'
import ActivityCard from './ActivityCard'
import ActivitiesContext from './ActivitiesContext'
import ActivitiesPage from './ActivitiesPage'

export interface Day {
  key: any;
  dayName: string;
  dayNumber: number;
  date: any;
  activities: any[];
}

interface Props {
  days: Day[];
}

interface State {
  selectedKey: string;
}

export default class ActivitySelector extends React.Component<Props, State> {
  static contextType = ActivitiesContext

  state = {
    selectedKey: ''
  }

  componentWillMount () {
    const { days } = this.props
    if( days[0] ) {
      this.setState({
        selectedKey: days[0].key
      })
    }
  }

  handleClick = (day: Day) => {
    this.setState({ selectedKey: day.key })
  }

  render() {
    const { selectedKey } = this.state
    const { days } = this.props

    return (
      <React.Fragment>
        <Container>
          <Wrapper>
            {days.map((day: Day) => (
              <Day selected={selectedKey === day.key} onClick={() => this.handleClick(day)}>
                <p>{day.dayNumber}</p>
                <p>{day.dayName.slice(0, 3)}</p>
              </Day>
            ))}
          </Wrapper>
        </Container>
        {this.renderPage()}
      </React.Fragment>
    )
  }

  renderPage = () => {
    const { selectedKey } = this.state
    const { days } = this.props


    const day = days.find(d => d.key === selectedKey)

    if (!day) {
      return null
    }

    return (
      <ActivitiesPage
        key={selectedKey}
        activities={day.activities}
      />
    )
  }
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 18px;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  
  width: 100%;
  
  background-color: #1C3558;
  border-radius: 15px;
`

const Day = styled.button<any>`
  font-size: 15px;
  margin: 8px 8px 0;
  padding: 8px 20px 14px;
  display: block;
  background: none;
  border: 1px solid transparent;
  outline: none;
  cursor: pointer;
  transition: all .2s ease-in-out;
  color: #FFF;

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  
  p {
   margin: 0; 
  }
  
  p:first-child {
    font-size: 20px;
    font-weight: 600;
    line-height: 20px;
  }
  
  p:last-child {
    font-size: 14px;
    text-transform: uppercase;  
    font-weight: 500;
  }
  
  @media screen and (max-width: 991px) {
    margin: 8px 8px 0;
    padding: 6px 18px 14px;
    
    p:first-child {
      font-size: 20px;
    }
    
    p:last-child {
      font-size: 12px;
    }
  }
  
  @media screen and (max-width: 600px) {
    margin: 8px 8px 0;
    padding: 6px 10px 14px;
    
    p:first-child {
      font-size: 18px;
    }
    
    p:last-child {
      font-size: 10px;
    }
  }
  
  @media screen and (max-width: 350px) {
    margin: 8px 8px 0;
    padding: 6px 5px 14px;
    
    p:first-child {
      font-size: 18px;
    }
    
    p:last-child {
      font-size: 10px;
    }
  }
  
  ${({selected}) => selected && `
    background-color: #5A87CD;
    border-color: #5A87CD;
    box-shadow: 0px 0px 12px rgba(0,0,0,.07);
  `}
`